<template>
  <TaggableTagsCard
    ref="taggableTagsCard"
    title="Task Tags"
    :taggable-id="task.id"
    :taggable-type="task.object_type"
    :initial-tags="initialTags"
    :readonly="readonly"
    :context="context"
    @changed="emit('changed', $event)"
    @count-changed="emit('count-changed', $event)"
  />
</template>

<script setup>
import { computed, ref } from 'vue'
import TaggableTagsCard from '@Tags/components/tags/TaggableTagsCard.vue'

const emit = defineEmits(['changed', 'count-changed'])

const props = defineProps({
  task: {
    type: Object,
    required: true,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
  context: {
    type: String,
    default: 'task-tags',
  },
})

const taggableTagsCard = ref(null)
const initialTags = computed(() => {
  if (Array.isArray(props.task?.tags)) {
    return props.task.tags
  }

  if (Array.isArray(props.task?.cached?.tags)) {
    return props.task.cached.tags
  }

  return []
})

const fetchTags = async () => {
  await taggableTagsCard.value?.fetchTags?.()
}

defineExpose({
  fetchTags,
})
</script>
